// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-scrollpanel.custombar .p-scrollpanel-wrapper{border-right:10px solid hsla(0,0%,98%,.8)}.p-scrollpanel.custombar .p-scrollpanel-bar{background-color:#6958d6;opacity:1;transition:background-color .3s}.p-scrollpanel.custombar .p-scrollpanel-bar:hover{background-color:var(--primary-400)}", ""]);
// Exports
module.exports = exports;
